import React, { useEffect, useState } from 'react'
import skipWaitingRoomStorage from 'services/skipWaitingRoomStorage'

export const useSkipWaitingRoom = (requestSupportHandler) => {
  useEffect(() => {
    const skip = localStorage.getItem('skipWaitingRoom')
    if (skip) {
      const timeout = setTimeout(() => {
        requestSupportHandler()
        skipWaitingRoomStorage.removeSkipWaitingRoom()
      }, 1000) // esperar 1 segundo
      return () => clearTimeout(timeout)
    }
  }, [requestSupportHandler])
}
